import { css } from 'styled-components';

export const rounded = css`
  border-radius: 4px;
  color: var(--color-mercari-blue);
`;

export const borderBlue = css`
  border: 1px solid var(--color-mercari-blue);
`;

export const margin = css`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const dail5css = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const hoverColorMap = {
  'mercari-blue': 'plain',
  orange: 'orange',
  'orange-2': 'orange',
  paypal: 'paypal',
  '': 'light-grey-2',
  white: 'underlay',
};
const genHover = (bg, color) => {
  const hoverColor = hoverColorMap[bg || color];
  const colorVar = `color: var(--hover-${hoverColor})`;
  // color hover => color is a required prop
  const hoverColorCss = color && !bg ? colorVar : '';
  const hoverBGColorCss =
    // bg color defined
    // OR color and bg not defined => White CTA Button
    bg || (!color && !bg) ? `background-${colorVar}}` : '';
  return `
    &:hover {
      ${hoverColorCss};
      ${hoverBGColorCss};
    }
  `;
};
export const hoverCss = css`
  ${({ hasHover, disabled, bg = '', color = '' }) => {
    if (!hasHover || disabled) {
      return '';
    }
    return genHover(bg, color);
  }}
`;
export const boxShadowCss = css`
  content: ' ';
  position: absolute;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 10px var(--color-alpha-grey-28);
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 200ms;
`;
